export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8818.9ce7b9de.jpg";